import { render, staticRenderFns } from "./NoneSetting.vue?vue&type=template&id=571da549&scoped=true&"
import script from "./NoneSetting.vue?vue&type=script&lang=js&"
export * from "./NoneSetting.vue?vue&type=script&lang=js&"
import style0 from "./NoneSetting.vue?vue&type=style&index=0&id=571da549&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571da549",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('571da549')) {
      api.createRecord('571da549', component.options)
    } else {
      api.reload('571da549', component.options)
    }
    module.hot.accept("./NoneSetting.vue?vue&type=template&id=571da549&scoped=true&", function () {
      api.rerender('571da549', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Settings/NoneSetting.vue"
export default component.exports